import { push } from 'modules/gtm/modules/common';
import { MetaData } from 'modules/gtm/modules/types';

export const gtmPushPageMeta = (data: MetaData) => {
  push({
    event: 'Page Meta',
    ...data,
  });
};

export const gtmPushVirtualPageView = ({
  path,
  title,
}: Record<string, unknown>) => {
  push({
    event: 'virtual_page_view',
    page_path: path,
    page_title: title,
  });
};

export const gtmPushDownload = ({
  fileName,
  linkUrl,
}: Record<string, string>) => {
  push({
    event: 'Generic Event',
    event_name: 'downloads',
    downloads: {
      file_name: fileName,
      link_url: linkUrl,
      event_category: 'downloads',
      event_action: fileName,
      event_label: linkUrl,
    },
  });
};

export const gtmPushVirtualUrl = (url: string) => {
  push({
    virtualUrl: url,
  });
};

export const gtmPushPageCategory = (path: string) => {
  push({
    pageCategory: path,
  });
};
